import styled from 'styled-components';

export const RadioContainer = styled.div`
  width: min-content;
  white-space: nowrap;
`;
